<script>
    import { apiMethods } from "../../../../../Services/index.svelte";
    import { defaultErrorMsgPrompt } from "../../../../../Utils/utilConstants.svelte";
    import { DirectInsuranceType } from "../../../../../Utils/utilEnums.svelte";
    import { getValidBillingData, showError } from "../../../../../Utils/utilFunctions.svelte";
    import { CustomTooltip } from "../../../../Common/index.svelte";
    import Loader from "../../../../Common/Loader.svelte";
    import NotificationModal from "../../../../Common/NotificationModal.svelte";

    export let encounter;
    export let onSuccess = () => {};

    let isCheckingOPV = false, isOpvResultModalOpen = false, opvVerificationSuccess = false, opvResponseWithErrorMsg = '', opvResultMsg = '';


    const runOpvCheck = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const { id } = encounter;
        isCheckingOPV = true;

        if (id) {
            apiMethods.postMethod
                .checkOPV({
                    patientEncounterId: id,
                })
                .then((res) => {
                    isCheckingOPV = false;
                    isOpvResultModalOpen = true;

                    if (!res || res.error) {
                        opvVerificationSuccess = false;
                        opvResponseWithErrorMsg = !!res.error;
                        opvResultMsg = res.error
                            ? res.error
                            : defaultErrorMsgPrompt;
                    } else {
                        //handle on success
                        _handleOPVResponse(res);
                    }
                });
        } else {
            isCheckingOPV = false;
            showError(
                "Missing patient encounter id, please contact support...",
            );
        }
    };

      const _handleOPVResponse = (response) => {
        const { billingData, patient: patientDetails } = encounter;
        const {
            suggestedMedicareNum,
            suggestedMedicareReference,
            suggestedName,
            suggestedLastName,
            suggestedInsuranceId,
            suggestedBirthdate,
            medicareStatus,
            medicareText,
            healthFundStatus,
            healthFundText,
            veteranStatus,
            veteranText,
        } = response;

        const validSuggestions =
            suggestedMedicareNum ||
            suggestedMedicareReference ||
            suggestedName ||
            suggestedLastName ||
            suggestedInsuranceId ||
            suggestedBirthdate;

        if (!validSuggestions) {
            const encounterInsuranceType = isObjectEmpty(
                getValidBillingData(billingData),
            )
                ? patientDetails.insuranceType
                : getValidBillingData(billingData).insuranceType;

            isOpvResultModalOpen = true;

            if (encounterInsuranceType == DirectInsuranceType.DVA) {
                opvVerificationSuccess = veteranStatus == 1;
                opvResultMsg = veteranText;
            } else if (encounterInsuranceType == DirectInsuranceType.Private) {
                opvVerificationSuccess =
                    medicareStatus == 1 && healthFundStatus == 1;
                if (medicareText && medicareStatus != 1)
                    opvResultMsg = `Medicare: ${medicareText} <br />`;
                if (healthFundText && healthFundStatus != 1)
                    opvResultMsg += `Health Fund: ${healthFundText}`;
            } else {
                opvVerificationSuccess = medicareStatus == 1;
                opvResultMsg = medicareText;
            }

        } 
    };
</script>

<CustomTooltip
    contentClass="bg-[#fff] border-none flex-wrap text-left"
    contentStyle="box-shadow: 4px 4px 13.7px 1px rgba(0, 0, 0, 0.25);"
    zIndex="20"
>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        on:click|preventDefault|stopPropagation={runOpvCheck}
        class="flex  justify-center cursor-pointer"
        slot="tooltipTrigger"
    >
        {#if isCheckingOPV}
            <Loader />
        {:else}
            <i class="fa-solid fa-refresh"></i>
        {/if}
    </div>

    <p>Rerun OPV check</p>
</CustomTooltip>


<NotificationModal
    isModalOpen={isOpvResultModalOpen}
    title={opvVerificationSuccess
        ? "Verification Complete"
        : opvResponseWithErrorMsg
          ? "Verification Failed"
          : "Verification Error"}
    closeModal={(e) => {
        e.stopPropagation();

        isOpvResultModalOpen = false;
        opvVerificationSuccess = false;
        opvResponseWithErrorMsg = false;
        opvResultMsg = "";

        if(opvVerificationSuccess && onSuccess){
            onSuccess(encounter); //call the success function
        }
    }}
    closeModalFunction={(e) => {
        e.stopPropagation();

        isOpvResultModalOpen = false;
        opvVerificationSuccess = false;
        opvResponseWithErrorMsg = false;
        opvResultMsg = "";

        if(opvVerificationSuccess && onSuccess){
            onSuccess(encounter); //call the success function
        }
    }}
    showConfirmBtn={false}
    cancelText="Close"
>
    <div class="flex-1 flex flex-col items-start">
        {#if opvVerificationSuccess}
            <p class="leading-6 p-4 text-secondary">
                Patient verified successfully.
            </p>
        {:else}
            {#if !opvResponseWithErrorMsg}
                <p class="leading-6 p-4 text-error">Failed to verify patient.</p>
            {/if}
            <p class="leading-6 p-4 text-error">
                {@html opvResultMsg}
            </p>
        {/if}
    </div>
    
</NotificationModal>

<style>
    .text-error {
        font-size:16px;
    }
</style>
